var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLcsNotInUsePumpOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Connected_NOT_in_use_Circulation_Pump_OFF",
    "data-name": "Connected + NOT in use_Circulation Pump OFF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9856",
    "data-name": "Group 9856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3892",
    "data-name": "Path 3892",
    d: "M37.18,42.83H7.12A5.826,5.826,0,0,1,1.3,37.01V7.12A5.819,5.819,0,0,1,7.12,1.3H37.18A5.819,5.819,0,0,1,43,7.12V37.01A5.826,5.826,0,0,1,37.18,42.83Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3893",
    "data-name": "Path 3893",
    d: "M38.01,11.8a2.057,2.057,0,0,0-2.43.53L29.72,10.9l.45-.94a2.5,2.5,0,0,0-1.9-2.64L18.25,4.88a2.258,2.258,0,0,0-2.67,1.61l-.86,4.01a2.5,2.5,0,0,0,1.91,2.63l1.7.42-5.4,18.38L7.72,42.83H20.18l2.91-6.08.22-.47,2.11-20.32a1.728,1.728,0,0,0,.2-.86l.86.41a2.258,2.258,0,0,0,2.67-1.61l.18-1.26,6.03,1.52a2.247,2.247,0,0,0,2.19,1.35,1.854,1.854,0,0,0,1.79-1.57A2.107,2.107,0,0,0,38.01,11.8Z",
    fill: "#6a7084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3894",
    "data-name": "Path 3894",
    d: "M37.15,44.13h-30A7.151,7.151,0,0,1,0,37V7.12A7.149,7.149,0,0,1,7.15,0h30A7.149,7.149,0,0,1,44.3,7.12V37A7.151,7.151,0,0,1,37.15,44.13ZM7.15,2.6A4.535,4.535,0,0,0,2.61,7.13V37a4.541,4.541,0,0,0,4.54,4.53h30A4.535,4.535,0,0,0,41.69,37V7.12a4.541,4.541,0,0,0-4.54-4.53h-30Z",
    fill: "#6a7084"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4307",
    "data-name": "Rectangle 4307",
    width: 53,
    height: 53,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLcsNotInUsePumpOff);
export default __webpack_public_path__ + "static/media/lcs_not_in_use_pump_off.28ce25f60ba014b15e80bd513ef31371.svg";
export { ForwardRef as ReactComponent };